import { Component, inject, ViewChild, Output, EventEmitter, Input, DestroyRef,OnDestroy  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DynamicFormsV2Component } from '../shared/dynamic-forms-v2/dynamic-forms-v2.component';
//import { DynamicFormsV2Component } from '../shared/dynamic-forms-v2/dynamic-forms-v2.component';
import { formMetaData, formFields } from '../shared/dynamic-forms.interface';
import { Router } from '@angular/router';
import { HumanName } from 'fhir/r4';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import {
  CodeableConceptField, CodeField, GroupField, IndividualField,
  codeableConceptDataType, ReferenceDataType, codingDataType,
  IndividualReferenceField, ReferenceFieldArray,
  SingleCodeField
} from '../shared/dynamic-forms.interface2';
import { FormFieldsSelectDataService } from '../shared/form-fields-select-data.service';
import { ErrorService } from '../shared/error.service';
import { forkJoin, map, of, switchMap, Subject,timer, debounceTime, distinctUntilChanged, switchMap as rxSwitchMap } from 'rxjs';
import { Bundle, BundleEntry, Consent, Group, Identifier, Patient, Reference } from 'fhir/r4';
import { MatTabsModule, MatTabGroup } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { UploadUiComponent } from "../upload-ui/upload-ui.component";
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PatientDataReviewComponent, FieldEditEvent } from '../shared/patient-data-review/patient-data-review.component';
import { SuccessMessageComponent } from '../shared/success-message/success-message.component';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { TEXT_COLUMN_OPTIONS } from '@angular/cdk/table';
import { backendEndPointToken, authBackendEndPointToken, hardCodedCodeableConceptOptions, hardCodedHospitalId, terminologyCanonicalUrlBaseToken } from '../app.config';
import { AuthService, User } from '../shared/auth/auth.service';
import { ConfirmationDialogComponent } from '../shared/confirmation-dialog/confirmation-dialog.component';
import { PatientRegistrationSuccessDialogComponent } from './patient-registration-success-dialog.component';
import { TenantMetadataService } from '../shared/tenant-metadata.service';
import { PatientDuplicateCheckService } from '../shared/patient-duplicate-check.service';


enum RegistrationFlow {
  SELF_REGISTRATION = 'patient-self-registration',  // Patient registers themselves → requires approval
  PRACTITIONER_INITIATED = 'practitioner-initiated' // Practitioner registers patient → auto-approved
}

type FormFields = IndividualField | ReferenceFieldArray | CodeableConceptField | CodeField | IndividualReferenceField | GroupField;
type AgreementKey = 'privacyPolicy' | 'treatmentConsent' | 'telemedicineConsent' | 'termsOfService' | 'notificationsOptIn';

@Component({
  selector: 'app-patient-registration',
  imports: [DynamicFormsV2Component, RouterLink, RouterLinkActive,
    MatTabsModule, UploadUiComponent, CommonModule, MatButtonModule, MatCardModule,
    MatIconModule, MatCheckboxModule, PatientDataReviewComponent],
  templateUrl: './patient-registration.component.html',
  styleUrl: './patient-registration.component.scss'
})
export class PatientRegistrationComponent implements OnDestroy {
  @Output() registrationComplete = new EventEmitter<void>();
  destroyRef = inject(DestroyRef);

  designatedRegForm?: formMetaData;
  selectedTabIndex = 0;
  designatedFormFields?: FormFields[];
  guardianFormFields?: FormFields[];
  guardianRegForm?: formMetaData;

relationshipOnlyFormFields: FormFields[] = [];
  @ViewChild('tabGroup') tabGroup!: MatTabGroup;

  formFieldsDataService = inject(FormFieldsSelectDataService);
  // errorService = inject(ErrorService);
  private router = inject(Router);
  private dupCheck = inject(PatientDuplicateCheckService);
  /** Populated after initializeRegistrationFlow() resolves this.organizationId */
  customValidators: Record<string, any> = {};
  loadedFieldSelectData: any;
  private hospitalBannerRef?: MatSnackBarRef<any>;

  registrationFlow: RegistrationFlow = RegistrationFlow.PRACTITIONER_INITIATED;
  organizationId: string = '';
  organizationDisplayName: string = '';
  isLoggedIn: boolean = false;
  canSelectOrganization: boolean = false;
  @Input() isInlineMode: boolean = false;
  private readonly requiredAgreementKeys: AgreementKey[] = ['privacyPolicy', 'treatmentConsent', 'telemedicineConsent', 'termsOfService'];
  readonly agreementLinks: Record<AgreementKey, string> = {
    privacyPolicy: '/app/legal/privacy-policy',
    treatmentConsent: '/app/legal/consent-for-treatment',
    telemedicineConsent: '/app/legal/telemedicine-consent',
    termsOfService: '/app/legal/terms-of-service',
    notificationsOptIn: '/app/preferences/notifications'
  };
  readonly telemedicineConsentStatements: string[] = [
    'I consent to receive medical treatment and healthcare services from practitioners of this hospital.',
    'I understand that consultations may occur through telemedicine and that remote care has limitations.'
  ];
  patientAgreementState: Record<AgreementKey, { accepted: boolean; acceptedOn: string | null }> = this.createAgreementDefaults();
  private createAgreementDefaults(): Record<AgreementKey, { accepted: boolean; acceptedOn: string | null }> {
    return {
      privacyPolicy: { accepted: false, acceptedOn: null },
      treatmentConsent: { accepted: false, acceptedOn: null },
      telemedicineConsent: { accepted: false, acceptedOn: null },
      termsOfService: { accepted: false, acceptedOn: null },
      notificationsOptIn: { accepted: false, acceptedOn: null }
    };
  }
  get hasAcceptedRequiredAgreements(): boolean {
    return this.requiredAgreementKeys.every(key => this.patientAgreementState[key].accepted);
  }
  get isSelfRegistrationFlow(): boolean {
  return this.registrationFlow === RegistrationFlow.SELF_REGISTRATION;
}
  isSubmissionDisabled(): boolean {
    return this.getRequiredErrorCount() > 0 || !this.hasAcceptedRequiredAgreements;
  }
  onAgreementToggle(key: AgreementKey, checked: boolean): void {
    this.patientAgreementState[key] = {
      accepted: checked,
      acceptedOn: checked ? new Date().toISOString() : null
    };
  }
  ngOnInit() {
    this.initializeRegistrationFlow();
    this.initializeEmptyPatient();

    // ✅ For self-registration, use static data — no auth needed
    const isSelfReg = this.registrationFlow === RegistrationFlow.SELF_REGISTRATION;

    const dataRequests: any = {
      gender: isSelfReg
        ? of(['Male', 'Female', 'Other', 'Unknown'])
        : this.formFieldsDataService.getFormFieldSelectData('patient', 'gender'),

      maritalStatus: isSelfReg
        ? of(this.getStaticMaritalStatus())
        : this.formFieldsDataService.getFormFieldSelectData('patient', 'maritalStatus'),

      relationship: isSelfReg
        ? of(this.getStaticRelationships())
        : this.formFieldsDataService.getFormFieldSelectData('patient', 'relationship'),

      contactPointUse: isSelfReg
        ? of(['home', 'work', 'temp', 'old', 'mobile'])
        : this.formFieldsDataService.getFormFieldSelectData('patient', 'contactPointUse'),

      contactPointSystem: isSelfReg
        ? of(['phone', 'fax', 'email', 'pager', 'url', 'sms', 'other'])
        : this.formFieldsDataService.getFormFieldSelectData('patient', 'contactPointSystem'),

      general_Practitioner: of([]),
      organization: of([]),
    };
// Wire up debounced guardian search
this.guardianSearchSubscription = this.guardianSearchSubject.pipe(
  debounceTime(400),
  distinctUntilChanged(),
  switchMap((query: string) => {
    if (!query || query.trim().length < 3) {
      this.guardianSearchResults = [];
      this.guardianSearchLoading = false;
      this.guardianSearchError = null;
      return of([]);
    }

    this.guardianSearchLoading = true;
    this.guardianSearchError = null;

    return this.http.get<any[]>(
      `${this.authBackendApiBaseUrl}/api/Admin/patients/search`,
      {
        params: {
          q: query.trim(),
          organizationId: this.organizationId
        }
      }
    );
  })
).subscribe({
  next: (results: any) => {
    this.guardianSearchLoading = false;
    this.guardianSearchResults = Array.isArray(results) ? results : [];
  },
  error: (err: any) => {
    this.guardianSearchLoading = false;
    this.guardianSearchError = 'Search failed. Please try again.';
    this.guardianSearchResults = [];
    console.error('Guardian search error:', err);
  }
});
    forkJoin(dataRequests).pipe().subscribe({
      next: (g: any) => {
        this.designatedRegForm = <formMetaData>{
          formName: 'Patient Registration',
          formDescription: "Register Form",
          submitText: 'Next ',
        };

        this.designatedFormFields = [

          <IndividualField>{

            generalProperties: {


              fieldApiName: 'active',
              fieldName: 'is Record in Active Use',
              fieldLabel: 'is Record in Active Use',
              isHidden: true,

              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
              value: false,
              inputType: "checkbox",
              isArray: false,

              isGroup: false
            },



          },
          <GroupField>{

            generalProperties: {

              fieldApiName: 'name',
              fieldName: 'Name',
              fieldLabel: 'Name',

              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
              fieldType: "IndividualField",
              isArray: false,
              isGroup: true
            },
            keys: ["given", "family", "title", "otherNames"],
            groupFields: {
              title: <IndividualField>{
                generalProperties: {

                  fieldApiName: 'title',
                  fieldName: 'Title',
                  fieldLabel: 'Title',
                  fieldPlaceholder: "Mr. Mrs.",

                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false
                },
                data: 'null'
              },
              family: <IndividualField>{
                generalProperties: {

                  fieldApiName: 'family',
                  fieldName: 'Last Name / Surname',
                  fieldLabel: 'Last Name / Surname',
                  validations: [
                    {
                      type: 'default',
                      name: 'required',
                      isFunction: false

                    }

                  ],
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false

                }

              },
              given: <IndividualField>{
                generalProperties: {

                  fieldApiName: 'given',
                  fieldName: 'First Name',
                  fieldLabel: 'First Name',
                  validations: [
                    {
                      type: 'default',
                      name: 'required',
                      isFunction: false

                    }

                  ],
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false

                }
              },
              otherNames: <IndividualField>{
                generalProperties: {

                  fieldApiName: 'otherNames',
                  fieldName: 'Other Names',
                  fieldLabel: 'Other Names',

                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false

                }

              }


            },
          },
          <IndividualField>{
            generalProperties: {
              fieldApiName: 'nin',
              fieldName: 'NIN if available',
              fieldLabel: 'NIN if available',
              fieldHint: 'Hospital Id will be generated later',
              validations: [
                {
                  type: 'custom',
                  name: 'ninExists',
                  isFunction: false
                }
              ],
              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
              fieldType: "IndividualField",
              isArray: false,
              isGroup: false
            }
          },
          <GroupField>{
            generalProperties: {
              fieldApiName: 'ids',
              fieldName: 'Other Identification Number',
              fieldLabel: 'Other Identification Number',
              fieldHint: 'Hospital Id will be generated later',
              groupFieldsHint: "Add other identification numbers if available",
              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
              fieldType: "IndividualField",
              isArray: true,
              isGroup: true
            },

            keys: ['value', 'type'],
            groupFields: {
              'value': <IndividualField>{
                generalProperties: {
                  fieldApiName: 'value',
                  fieldName: 'Id Number',
                  fieldLabel: 'Id Number',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  isArray: false,
                  isGroup: false
                }
              },

              'type': {
                generalProperties: {
                  fieldApiName: 'type',
                  fieldName: 'ID Type',
                  fieldLabel: 'ID Type',
                  fieldHint: 'Type of Identification Number e.g Passport, Drivers License',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  allowedOthers: true,
                  fieldType: "CodeableConceptField",
                  isArray: false,
                  isGroup: false
                },
                data: hardCodedCodeableConceptOptions['identifier.type']
              }
            },
          },
          <GroupField>{

            generalProperties: {
              fieldApiName: 'phone_telecom',
              fieldName: 'Phone Number',
              fieldLabel: 'Phone Number',
              fieldType: 'IndividualField',
              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },

              isArray: true,
              isGroup: true,
              hiddenFields: ['system'], // Hide the system field in dialogs
            },
            keys: ['value', 'use'],
            groupFields: {
              'value': <IndividualField>{
                generalProperties: {
                  fieldApiName: 'value',


                  fieldName: 'Phone Number ',
                  fieldLabel: 'Phone Number',

                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false

                }


              },
              'system': <CodeField>{
                generalProperties: {
                  fieldApiName: 'system',
                  fieldName: 'Contact Platform',
                  fieldLabel: 'Contact Platform',
                  fieldType: 'CodeField',

                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  value: "phone",
                  isHidden: true,
                  isArray: false,
                  isGroup: false
                },
                data: g.contactPointSystem
              },
              'use': <CodeField>{
                generalProperties: {
                  fieldApiName: 'use',
                  fieldName: 'Contact Type',
                  fieldLabel: 'Contact Type',
                  fieldType: 'CodeField',
                  value: "mobile",
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false
                },
                data: g.contactPointUse
              },



            },
          },
          <GroupField>{

            generalProperties: {
              fieldApiName: 'email_telecom',
              fieldName: 'Email',
              fieldLabel: 'Email',
              fieldType: 'IndividualField',
              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },

              isArray: true,
              isGroup: true,
              hiddenFields: ['system'], // Hide the system field in dialogs
            },
            keys: ['value', 'use'],
            groupFields: {
              'value': <IndividualField>{
  generalProperties: {
    fieldApiName: 'value',
    fieldName: 'Email ',
    fieldLabel: 'Email',
    validations: isSelfReg
      ? [
          { type: 'default', name: 'required', isFunction: false },
          { type: 'default', name: 'email', isFunction: false },
          { type: 'custom', name: 'emailExists', isFunction: false }
        ]
      : [
          { type: 'default', name: 'email', isFunction: false },
          { type: 'custom', name: 'emailExists', isFunction: false }
        ],
    auth: { read: 'all', write: 'doctor, nurse' },
    isArray: false,
    isGroup: false
  }
},
              'system': <CodeField>{
                generalProperties: {
                  fieldApiName: 'system',
                  fieldName: 'Contact Platform',
                  fieldLabel: 'Contact Platform',
                  fieldType: 'CodeField',

                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  value: "email",
                  isHidden: true,
                  isArray: false,
                  isGroup: false
                },
                data: g.contactPointSystem
              },
              'use': <CodeField>{
                generalProperties: {
                  fieldApiName: 'use',
                  fieldName: 'Contact Type',
                  fieldLabel: 'Contact Type',
                  fieldType: 'CodeField',
                  // isHidden: true,
                  value: 'home',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false
                },
                data: g.contactPointUse
              },



            },
          },
          <GroupField>{

            generalProperties: {
              fieldApiName: 'telecom',
              fieldName: 'Other Contacts',
              fieldLabel: 'Other Contacts',
              groupFieldsHint: 'Add other contact methods apart from email (e.g., phone, fax, SMS)',
              fieldType: 'IndividualField',
              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },

              isArray: true,
              isGroup: true
            },
            keys: ['value', 'system', 'use'],
            groupFields: {
              'value': <IndividualField>{
                generalProperties: {
                  fieldApiName: 'value',
                  fieldHint: 'Add other contact methods apart from email (e.g., phone, fax, SMS)',


                  fieldName: 'Contact ',
                  fieldLabel: 'Contact',

                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false

                }


              },
              'system': <CodeField>{
                generalProperties: {
                  fieldApiName: 'system',
                  fieldName: 'Contact Platform',
                  fieldLabel: 'Contact Platform',
                  fieldType: 'CodeField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false
                },
                data: g.contactPointSystem
              },
              'use': <CodeField>{
                generalProperties: {
                  fieldApiName: 'use',
                  fieldName: 'Contact Type',
                  fieldLabel: 'Contact Type',
                  fieldType: 'CodeField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false
                },
                data: g.contactPointUse
              },



            },
          },
          <CodeField>{

            generalProperties: {
              fieldApiName: 'gender',
              fieldName: 'Gender',
              fieldLabel: 'Gender',
              fieldType: 'CodeField',
              validations: [
                {
                  type: 'default',
                  name: 'required',
                  isFunction: false

                }

              ],
              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
              isArray: false,
              isGroup: false
            },
            data: g.gender?.map((item: any) => item[0].toUpperCase() + item.slice(1).toLowerCase())
          },
          <IndividualField>{

            generalProperties: {
              fieldApiName: 'birthDate',
              fieldName: 'Date of Birth',
              fieldLabel: 'Date of Birth',
              fieldType: 'IndividualField',
              inputType: 'datetime-local',
              validations: [
                {
                  type: 'default',
                  name: 'required',
                  isFunction: false

                }

              ],
              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },

              isArray: false,
              isGroup: false
            }
          },
          <GroupField>{

            generalProperties: {
              fieldApiName: 'address',
              fieldName: 'Address',
              fieldLabel: 'Address',
              fieldType: 'IndividualField',
              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },

              isArray: true,
              isGroup: true
            },



            keys: ['line', 'city', 'state', 'country', 'postalCode'],
            groupFields: {
              line: <IndividualField>{
                generalProperties: {
                  fieldApiName: 'line',
                  fieldName: 'Adress Line',
                  fieldLabel: 'Address Line',
                  fieldType: 'IndividualField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  isArray: false,
                  isGroup: false


                }
              },

              city: <IndividualField>{
                generalProperties: {
                  fieldApiName: 'city',
                  fieldName: 'City',
                  fieldLabel: 'City',
                  fieldType: 'IndividualField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  isArray: false,
                  isGroup: false
                }
              },

              state: <IndividualField>{
                generalProperties: {
                  fieldApiName: 'state',
                  fieldName: 'State',
                  fieldLabel: 'State',
                  fieldType: 'IndividualField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  isArray: false,
                  isGroup: false
                }
              },
              postalCode: <IndividualField>{
                generalProperties: {
                  fieldApiName: 'postalCode',
                  fieldName: 'Postal Code',
                  fieldLabel: 'Postal Code',
                  fieldType: 'IndividualField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  isArray: false,
                  isGroup: false
                }

              },
              country: <IndividualField>{
                generalProperties: {
                  fieldApiName: 'country',
                  fieldName: 'Country',
                  fieldLabel: 'Country',
                  fieldType: 'IndividualField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  isArray: false,
                  isGroup: false
                }
              },

            }
          },
          <CodeableConceptField>{
            generalProperties: {
              fieldApiName: 'maritalStatus',
              fieldName: 'Marital Status',
              fieldLabel: 'Marital Status',
              fieldType: 'CodeableConceptField',
              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
              isArray: false,
              isGroup: false
            },
            data: g.maritalStatus

          },


        ];
        if (this.canSelectOrganization) {
          this.designatedFormFields.push(<IndividualReferenceField>{
            generalProperties: {
              fieldApiName: 'managingOrganization',
              fieldName: 'Managing Organization',
              fieldLabel: 'Managing Organization',
              fieldType: 'IndividualReferenceField',
              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
              isArray: false,
              isGroup: false
            },
            data: g.organization

          });
        }
        this.guardianRegForm =
          <formMetaData>{
            formName: 'Guardian Registration',
            formDescription: "Guardian Register Form",
            submitText: ' Next ',
          };
        this.guardianFormFields = [
          <CodeableConceptField>{
            generalProperties: {
              fieldApiName: 'relationship',
              fieldName: 'Relationship to Patient',
              fieldLabel: 'Relationship to Patient',
              fieldType: 'CodeableConceptField',
              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
              isArray: false,
              isGroup: false
            },
            data: g.relationship
          },


          <GroupField>{

            generalProperties: {

              fieldApiName: 'name',
              fieldName: 'Guardian Name',
              fieldLabel: 'Guardian Name',

              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
              fieldType: "IndividualField",
              isArray: false,
              isGroup: true
            },
            keys: ["given", "family", "title", "otherNames"],
            groupFields: {
              title: <IndividualField>{
                generalProperties: {

                  fieldApiName: 'title',
                  fieldName: 'Title',
                  fieldLabel: 'Title',
                  fieldPlaceholder: "Mr. Mrs.",

                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false
                },
                data: 'null'
              },
              family: <IndividualField>{
                generalProperties: {

                  fieldApiName: 'family',
                  fieldName: 'Last Name / Surname',
                  fieldLabel: 'Last Name / Surname',

                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false

                }

              },
              given: <IndividualField>{
                generalProperties: {

                  fieldApiName: 'given',
                  fieldName: 'First Name',
                  fieldLabel: 'First Name',

                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false

                }
              },
              otherNames: <IndividualField>{
                generalProperties: {

                  fieldApiName: 'otherNames',
                  fieldName: 'Other Names',
                  fieldLabel: 'Other Names',

                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false

                }

              }


            },
          },
          <GroupField>{

            generalProperties: {
              fieldApiName: 'phone_telecom',
              fieldName: 'Guardian Phone Number',
              fieldLabel: 'Guardian Phone Number',
              fieldType: 'IndividualField',
              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },

              isArray: true,
              isGroup: true,
              hiddenFields: ['system'], // Hide the system field in dialogs
            },
            keys: ['value', 'use'],
            groupFields: {
              'value': <IndividualField>{
                generalProperties: {
                  fieldApiName: 'value',


                  fieldName: 'Phone Number ',
                  fieldLabel: 'Phone Number',

                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false

                }


              },
              'system': <CodeField>{
                generalProperties: {
                  fieldApiName: 'system',
                  fieldName: 'Contact Platform',
                  fieldLabel: 'Contact Platform',
                  fieldType: 'CodeField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  value: "phone",
                  isHidden: true,
                  isArray: false,
                  isGroup: false
                },
                data: g.contactPointSystem
              },
              'use': <CodeField>{
                generalProperties: {
                  fieldApiName: 'use',
                  fieldName: 'Contact Type',
                  fieldLabel: 'Contact Type',
                  fieldType: 'CodeField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false
                },
                data: g.contactPointUse
              },



            },
          },
          <GroupField>{

            generalProperties: {
              fieldApiName: 'email_telecom',
              fieldName: 'Guardian Email',
              fieldLabel: 'Guardian Email',
              fieldType: 'IndividualField',
              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },

              isArray: true,
              isGroup: true,
              hiddenFields: ['system'], // Hide the system field in dialogs
            },
            keys: ['value', 'use'],
            groupFields: {
              'value': <IndividualField>{
                generalProperties: {
                  fieldApiName: 'value',


                  fieldName: 'Email ',
                  fieldLabel: 'Email',

                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false

                }


              },
              'system': <CodeField>{
                generalProperties: {
                  fieldApiName: 'system',
                  fieldName: 'Contact Platform',
                  fieldLabel: 'Contact Platform',
                  fieldType: 'CodeField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  value: "email",
                  isHidden: true,
                  isArray: false,
                  isGroup: false
                },
                data: g.contactPointSystem
              },
              'use': <CodeField>{
                generalProperties: {
                  fieldApiName: 'use',
                  fieldName: 'Contact Type',
                  fieldLabel: 'Contact Type',
                  fieldType: 'CodeField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false
                },
                data: g.contactPointUse
              },



            },
          },
          <GroupField>{

            generalProperties: {
              fieldApiName: 'telecom',
              fieldName: 'Guardian Other Contacts',
              fieldLabel: 'Guardian Other Contacts',
              fieldType: 'IndividualField',
              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },

              isArray: true,
              isGroup: true
            },
            keys: ['value', 'system', 'use'],
            groupFields: {
              'value': <IndividualField>{
                generalProperties: {
                  fieldApiName: 'value',


                  fieldName: 'Contact ',
                  fieldLabel: 'Contact',

                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false

                }


              },
              'system': <CodeField>{
                generalProperties: {
                  fieldApiName: 'system',
                  fieldName: 'Contact Platform',
                  fieldLabel: 'Contact Platform',
                  fieldType: 'CodeField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false
                },
                data: g.contactPointSystem
              },
              'use': <CodeField>{
                generalProperties: {
                  fieldApiName: 'use',
                  fieldName: 'Contact Type',
                  fieldLabel: 'Contact Type',
                  fieldType: 'CodeField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },

                  isArray: false,
                  isGroup: false
                },
                data: g.contactPointUse
              },



            },
          },
          <CodeField>{

            generalProperties: {
              fieldApiName: 'gender',
              fieldName: 'Guardian Gender',
              fieldLabel: 'Guardian Gender',
              fieldType: 'CodeField',
              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },
              isArray: false,
              isGroup: false
            },
            data: g.gender
          },

          <GroupField>{

            generalProperties: {
              fieldApiName: 'address',
              fieldName: 'Guardian Address',
              fieldLabel: 'Guardian Address',
              fieldType: 'IndividualField',
              auth: {
                read: 'all',
                write: 'doctor, nurse'
              },

              isArray: true,
              isGroup: true
            },



            keys: ['line', 'city', 'state', 'country', 'postalCode'],
            groupFields: {
              line: <IndividualField>{
                generalProperties: {
                  fieldApiName: 'line',
                  fieldName: 'Adress Line',
                  fieldLabel: 'Address Line',
                  fieldType: 'IndividualField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  isArray: true,
                  isGroup: false


                }
              },

              city: <IndividualField>{
                generalProperties: {
                  fieldApiName: 'city',
                  fieldName: 'City',
                  fieldLabel: 'City',
                  fieldType: 'IndividualField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  isArray: false,
                  isGroup: false
                }
              },

              state: <IndividualField>{
                generalProperties: {
                  fieldApiName: 'state',
                  fieldName: 'State',
                  fieldLabel: 'State',
                  fieldType: 'IndividualField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  isArray: false,
                  isGroup: false
                }
              },
              postalCode: <IndividualField>{
                generalProperties: {
                  fieldApiName: 'postalCode',
                  fieldName: 'Postal Code',
                  fieldLabel: 'Postal Code',
                  fieldType: 'IndividualField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  isArray: false,
                  isGroup: false
                }

              },
              country: <IndividualField>{
                generalProperties: {
                  fieldApiName: 'country',
                  fieldName: 'Country',
                  fieldLabel: 'Country',
                  fieldType: 'IndividualField',
                  auth: {
                    read: 'all',
                    write: 'doctor, nurse'
                  },
                  isArray: false,
                  isGroup: false
                }
              },

            }
          },


        ];
this.relationshipOnlyFormFields = this.guardianFormFields.filter(
  f => (f as any).generalProperties?.fieldApiName === 'relationship'
);
      },

      error: (err: any) => {
        this.errorService.openandCloseError("Error ocurred while preparing fields dropdowns for the form")
        console.log(err);
      }
    })
  }

ngOnDestroy(): void {
  this.guardianSearchSubscription?.unsubscribe();
}

  errorService = inject(ErrorService);
  dialog = inject(MatDialog);
  http = inject(HttpClient);
  snackBar = inject(MatSnackBar);

  submittedData: any = null;
  fhirPatient!: Patient; // Initialized in ngOnInit
  showForm: boolean = true;

  guardianSubmittedData: any = null;
  showGuardianForm: boolean = true;

  uploadedPhotos: any[] = []; // Store uploaded photos/documents

  // Validation and error handling
  validationErrors: string[] = [];
  showValidationBar: boolean = false;
  hasAttemptedSubmit: boolean = false; // Track if user has clicked submit

  // FHIR panel state
  isFhirPanelCollapsed: boolean = true; // Start collapsed

  // Validation tracker
  validationTracker: any = {
    required: {
      name: { valid: false, message: 'Patient must have both First Name and Last Name' },
      gender: { valid: false, message: 'Patient gender is required' },
      birthDate: { valid: false, message: 'Patient birth date is required' },
      telecom: { valid: false, message: 'Patient contact information (phone/email) is required' }
    },
    recommended: {
    }
  };

  // File upload restrictions
  photoAllowedFiles = /\.(jpg|jpeg|png|gif|pdf|docx|xlsx|txt)$/i;
  photoMaxFileSize = 52428800; // 50MB
  photoMaxFiles = 5;

  // Azure Storage configuration for file uploads (from azure-upload-demo)


  // Categorized fields for display
  simpleFields: any[] = [];
  arrayFields: any[] = [];
  // Guardian search state
guardianSearchQuery: string = '';
guardianSearchResults: any[] = [];
guardianSearchLoading: boolean = false;
guardianSearchError: string | null = null;
selectedGuardian: any | null = null;        // set when user confirms a search result
useExistingGuardian: boolean = false;       // toggle: search existing vs enter new

private guardianSearchSubject = new Subject<string>();
private guardianSearchSubscription?: any;

  /**
  * ✅ UPDATED: Initialize registration flow with inline mode awareness
  * Prevents logout when opened as inline component within parent
  */
  private initializeRegistrationFlow(): void {
    const currentUser = this.authService.user.getValue();
    this.isLoggedIn = !!currentUser && currentUser.isApproved;
    this.canSelectOrganization = !!currentUser && ((currentUser.role?.toLowerCase?.() === 'superadmin') || currentUser.isSuperAdmin === true);

    console.log('🔍 Initializing registration flow...');
    console.log('👤 Current user:', currentUser);
    console.log('📍 Inline Mode:', this.isInlineMode);

    // Check session storage for self-registration flow
    const flowFromSession = sessionStorage.getItem('registrationFlow') as RegistrationFlow;
    const hospitalIdFromSession = sessionStorage.getItem('selectedHospitalId');
    const hospitalNameFromSession = sessionStorage.getItem('selectedHospitalName');

    if (flowFromSession === RegistrationFlow.SELF_REGISTRATION && hospitalIdFromSession) {
      // ✅ SELF-REGISTRATION FLOW (Patient selects hospital)
      this.registrationFlow = RegistrationFlow.SELF_REGISTRATION;
      this.organizationId = hospitalIdFromSession;
      this.organizationDisplayName = hospitalNameFromSession || this.organizationDisplayName;

      console.log(`✅ SELF-REGISTRATION flow detected`);
      console.log(`🏥 Selected hospital: ${hospitalNameFromSession} (${hospitalIdFromSession})`);

      // Show hospital banner only if NOT in inline mode
      if (!this.isInlineMode) {
        this.showHospitalSelectionBanner(hospitalNameFromSession || 'Selected Hospital');
      }
    }
    else if (this.isLoggedIn && currentUser) {
      // ✅ PRACTITIONER-INITIATED FLOW (Staff registers patient)
      this.registrationFlow = RegistrationFlow.PRACTITIONER_INITIATED;
      this.organizationId = currentUser.organizationId ||
        currentUser['hospitalId'] ||
        hardCodedHospitalId;
      this.organizationDisplayName = this.resolveOrganizationDisplayFromUser(currentUser) || this.organizationDisplayName;

      console.log(`✅ PRACTITIONER-INITIATED flow detected`);
      console.log(`👨‍⚕️ Practitioner: ${currentUser.name} (${currentUser.role})`);
      console.log(`🏥 Organization: ${this.organizationId}`);

      // Clear session data
      sessionStorage.removeItem('registrationFlow');
      sessionStorage.removeItem('selectedHospitalId');
      sessionStorage.removeItem('selectedHospitalName');
    }
    else {
      // ✅ UPDATED: Handle invalid state differently based on mode
      console.warn('⚠️ Invalid registration state');

      if (this.isInlineMode) {
        // In inline mode, try to use current user's organization
        console.log('📋 In inline mode - attempting to use default organization');

        if (currentUser?.organizationId) {
          this.registrationFlow = RegistrationFlow.PRACTITIONER_INITIATED;
          this.organizationId = currentUser.organizationId;
          this.organizationDisplayName = this.resolveOrganizationDisplayFromUser(currentUser) || this.organizationDisplayName;
          console.log(`✅ Using current user organization: ${this.organizationId}`);
          return;
        } else {
          console.error('❌ No organization found for current user');
          this.errorService.openandCloseError('Organization ID is required');
          return;
        }
      } else {
        // Not in inline mode - redirect as before
        this.errorService.openandCloseError('Please select a hospital to continue registration');
        this.router.navigate(['/patient-hospital-selection']);
        return;
      }
    }

    // Validate organization ID
    if (!this.organizationId) {
      console.error('❌ Organization ID is missing');
      this.errorService.openandCloseError('Organization ID is required');

      // Only redirect if NOT in inline mode
      if (!this.isInlineMode) {
        this.router.navigate(this.registrationFlow === RegistrationFlow.SELF_REGISTRATION
          ? ['/patient-hospital-selection']
          : ['/']);
      }
      return;
    }

    console.log(`✅ Flow: ${this.registrationFlow}, Org: ${this.organizationId}`);
    // Rebuild the duplicate-check validators now that we know the org.
    // The _tag is baked into each validator at build time, so this must
    // run after organizationId is fully resolved.
    this.customValidators = this.dupCheck.buildValidatorRegistry(this.organizationId);
    if (this.registrationFlow === RegistrationFlow.SELF_REGISTRATION) {
  this.useExistingGuardian = false;
}
  }
  private showHospitalSelectionBanner(hospitalName: string): void {
    // Store the snackbar reference
    this.hospitalBannerRef = this.snackBar.open(`Registering at: ${hospitalName}`, 'Change', {
      duration: 0,
      horizontalPosition: 'right',
      verticalPosition: 'top'
    });

    // Handle the "Change" button action
    this.hospitalBannerRef.onAction().subscribe(() => {
      this.router.navigate(['/patient-hospital-selection']);
    });
  }
  async onDesignatedFormSubmit(formData: any) {
    console.log('📋 Designated Form Submitted (Raw):', formData);

    // Transform to FHIR Patient (including guardian data if available)
    // ✅ Now awaiting the async function
    const transformedPatient = await this.transformToFhirPatient(formData, this.guardianSubmittedData);
    this.fhirPatient = transformedPatient;
    this.submittedData = formData;
    this.showForm = false; // Hide form and show submitted data

    console.log('🔥 FHIR Patient:', transformedPatient);

    // Check validation continuously
    this.checkValidationContinuously();
  }

  /**
   * Handle field edit event from PatientDataReviewComponent
   * This is called in real-time when a field is edited in standalone mode
   */
  async onFieldEdited(event: FieldEditEvent) {
    console.log('🔄 Field edited:', event);

    // Update the submittedData
    if (event.isArray && event.arrayIndex !== undefined) {
      this.submittedData[event.fieldApiName][event.arrayIndex] = event.newValue;
    } else {
      this.submittedData[event.fieldApiName] = event.newValue;
    }

    // Re-transform to FHIR Patient with updated data (include guardian if exists)
    // ✅ Now awaiting the async function
    this.fhirPatient = await this.transformToFhirPatient(this.submittedData, this.guardianSubmittedData);

    console.log('🔥 FHIR Patient updated:', this.fhirPatient);

    // Check validation continuously
    this.checkValidationContinuously();
  }

  /**
   * Handle form value changes from dynamic forms component
   */
  async onFormValueChange(formData: any) {
    // Transform to FHIR Patient for validation
    this.fhirPatient = await this.transformToFhirPatient(formData, this.guardianSubmittedData);

    // Check validation continuously
    this.checkValidationContinuously();
  }

  /**
   * Handle navigate next event from PatientDataReviewComponent
   */
  async onNavigateToNext() {
    // Re-transform patient data to FHIR before moving to next tab
    if (this.submittedData) {
      // ✅ Now awaiting the async function
      this.fhirPatient = await this.transformToFhirPatient(this.submittedData, this.guardianSubmittedData);
      console.log('🔥 FHIR Patient updated before navigating to guardian tab:', this.fhirPatient);
    }


      this.selectedTabIndex = 1; // Move to Guardian/Dependent tab

  }

  /**
   * Handle guardian/dependent form submission
   */
onGuardianFormSubmit(formData: any) {
  this.guardianSubmittedData = this.selectedGuardian
    ? { ...this.guardianSubmittedData, ...formData }   // merge relationship into existing search-selection data
    : formData;                                         // manual entry: use as-is
  this.showGuardianForm = false;

  this.fhirPatient.contact = this.transformGuardianToFhirContact(this.guardianSubmittedData);
  this.checkValidationContinuously();
}

  /**
 * Called on every keyup in the guardian search input
 */
onGuardianSearchInput(query: string): void {
  this.guardianSearchQuery = query;
  if (!query || query.trim().length < 3) {
    this.guardianSearchResults = [];
    this.guardianSearchLoading = false;
    this.guardianSearchError = null;
  }
  this.guardianSearchSubject.next(query);
}

/**
 * Called when the user clicks a search result to confirm the guardian
 */
selectGuardian(patient: any): void {
  this.selectedGuardian = patient;
  this.guardianSearchResults = [];
  this.guardianSearchQuery = patient.fullName || '';
  this.guardianSearchError = null;

  // Store the guardian FHIR ID so submitPatientToServer can include it
  // guardianSubmittedData is already used for the manual form path;
  // for the search path we store it separately and merge at submit time
  this.guardianSubmittedData = {
    ...this.guardianSubmittedData,
    guardianFhirId: patient.fhirId,
    isExistingPatient: true
  };

  console.log('✅ Guardian selected:', patient);
}

/**
 * Clear the selected guardian and reset search
 */
clearGuardianSelection(): void {
  this.selectedGuardian = null;
  this.guardianSearchQuery = '';
  this.guardianSearchResults = [];
  this.guardianSearchError = null;
  this.guardianSubmittedData = null;
}
  /**
   * Handle guardian field edit event
   */
  onGuardianFieldEdited(event: FieldEditEvent) {
    console.log('🔄 Guardian field edited:', event);

    // Update the guardianSubmittedData
    if (event.isArray && event.arrayIndex !== undefined) {
      this.guardianSubmittedData[event.fieldApiName][event.arrayIndex] = event.newValue;
    } else {
      this.guardianSubmittedData[event.fieldApiName] = event.newValue;
    }

    // Update FHIR Patient contact information
    this.fhirPatient.contact = this.transformGuardianToFhirContact(this.guardianSubmittedData);
    console.log('🔥 FHIR Patient contact updated:', this.fhirPatient.contact);

    console.log('📝 Guardian data updated:', this.guardianSubmittedData);

    // Check validation continuously
    this.checkValidationContinuously();
  }

  /**
   * Handle navigate to next from guardian tab
   */
onGuardianNavigateNext() {
  if (this.guardianSubmittedData) {
    this.fhirPatient.contact = this.transformGuardianToFhirContact(this.guardianSubmittedData);
  }
  this.selectedTabIndex = 2;
  console.log('➡️ selectedTabIndex is now', this.selectedTabIndex, 'tabGroup.selectedIndex is', this.tabGroup?.selectedIndex);
}
  /**
   * Initialize empty FHIR Patient resource
   */
  initializeEmptyPatient(): void {
    this.fhirPatient = {
      resourceType: 'Patient',
      active: true,
      name: [],
      telecom: [],
      address: []
    };
    console.log('🔥 Empty FHIR Patient initialized:', this.fhirPatient);
  }
  backendApiBaseUrl = inject(backendEndPointToken)
  authBackendApiBaseUrl = inject(authBackendEndPointToken)
  canonicalTerminologyServer = inject(terminologyCanonicalUrlBaseToken);
  private tenantMetadataService = inject(TenantMetadataService);
  /**
   * Handle uploaded photos/documents from upload-ui component
   */
  onPhotosUploaded(files: any[]) {
    console.log('📸 Photos uploaded event received from upload-ui component');
    console.log('📸 Number of files:', files.length);
    console.log('📸 Files data:', files);

    this.uploadedPhotos = files;

    // Update FHIR Patient with photo attachments
    this.applyPhotoAttachments(this.fhirPatient);

    console.log('✅ FHIR Patient.photo updated successfully!');
    console.log('🔥 FHIR Patient.photo array:', this.fhirPatient.photo);
    console.log('🔥 Full FHIR Patient resource:', JSON.stringify(this.fhirPatient, null, 2));

    // Check validation continuously
    this.checkValidationContinuously();
  }

  /**
   * Continuously check validation and update tracker
   * This runs after every change to the FHIR Patient resource
   */
  checkValidationContinuously(): void {
    // Check REQUIRED fields
    const hasFamily = this.fhirPatient.name && this.fhirPatient.name.some(n => !!n.family);
    const hasGiven = this.fhirPatient.name && this.fhirPatient.name.some(n => n.given && n.given.length > 0 && !!n.given[0]);
    this.validationTracker.required.name.valid = !!(hasFamily && hasGiven);

    this.validationTracker.required.gender.valid = !!this.fhirPatient.gender;
    this.validationTracker.required.birthDate.valid = !!this.fhirPatient.birthDate;
    this.validationTracker.required.telecom.valid = !!(this.fhirPatient.telecom && this.fhirPatient.telecom.length > 0);

    // Update validation errors array
    this.validationErrors = [];

    // Add required field errors
    Object.values(this.validationTracker.required).forEach((field: any) => {
      if (!field.valid) {
        this.validationErrors.push(`❌ REQUIRED: ${field.message}`);
      }
    });

    // Add recommended field errors
    Object.values(this.validationTracker.recommended).forEach((field: any) => {
      if (!field.valid) {
        this.validationErrors.push(`⚠️ RECOMMENDED: ${field.message}`);
      }
    });

    // Show validation bar if there are any errors (required or recommended) AND user has attempted submit
    this.showValidationBar = this.validationErrors.length > 0 && this.hasAttemptedSubmit;

    console.log('📊 Validation Status:', {
      required: this.validationTracker.required,
      recommended: this.validationTracker.recommended,
      errors: this.validationErrors,
      showBar: this.showValidationBar,
      hasAttemptedSubmit: this.hasAttemptedSubmit
    });
  }

  /**
   * Validate FHIR Patient resource before submission
   * Based on FHIR R4 Patient resource requirements
   */
  validateFhirPatient(): boolean {
    // Validation is already done continuously, just check if there are required field errors
    const hasRequiredErrors = Object.values(this.validationTracker.required).some(field => !(field as any)?.valid);

    if (hasRequiredErrors) {
      this.errorService.openandCloseError('Please complete all required patient information');
      return false;
    }
    //get all Patient

    return true;
  }


  submitPatientToServer(): void {
    console.log('🚀 Submitting patient registration...');
    console.log('📋 Flow:', this.registrationFlow);
    console.log('🏥 Org ID:', this.organizationId);

    this.hasAttemptedSubmit = true;

    // Validate before submission
    if (!this.validateFhirPatient()) {
      console.error('❌ Validation failed:', this.validationErrors);
      this.errorService.openandCloseError('Please complete all required patient information');
      this.showValidationBar = true;
      return;
    }

    console.log('✅ Validation passed!');

    // Validate organization ID exists
    if (!this.organizationId) {
      this.errorService.openandCloseError('Organization ID is required.');
      return;
    }

    if (!this.hasAcceptedRequiredAgreements) {
      this.errorService.openandCloseError('Please review and accept the required agreements before continuing.');
      return;
    }

    console.log('🏥 Organization ID:', this.organizationId);

    const patientClone = structuredClone
      ? structuredClone(this.fhirPatient)
      : JSON.parse(JSON.stringify(this.fhirPatient));

    this.sanitizePatientResource(patientClone);

    // Clean up the FHIR Patient resource
    const cleanedPatient = this.pruneFHIRArrays(patientClone);

    // Ensure managingOrganization is set
    if (!cleanedPatient.managingOrganization) {
      cleanedPatient.managingOrganization = {
        reference: `Organization/${this.organizationId}`
      };
    }

    const displayForTag = this.getOrganizationDisplayNameForTag();
    const resolvedDisplay = this.tenantMetadataService.ensureTenantTag(
      cleanedPatient,
      this.organizationId,
      displayForTag
    );
    if (resolvedDisplay) {
      this.organizationDisplayName = resolvedDisplay;
    }

    console.log('🧹 Cleaned FHIR Patient:', cleanedPatient);

    // ✅ Route to correct endpoint based on registration flow
    if (this.registrationFlow === RegistrationFlow.SELF_REGISTRATION) {
      this.submitSelfRegistration(cleanedPatient);
    } else {
      this.submitPractitionerInitiatedRegistration(cleanedPatient);
    }
  }
private buildGuardianInfoPayload(): any | null {
  if (!this.guardianSubmittedData) return null;

  const g = this.guardianSubmittedData;

  // If an existing patient was selected via search, use their FHIR ID
  if (g.isExistingPatient && g.guardianFhirId) {
    return {
      GuardianFhirId: g.guardianFhirId,
      RelationshipCode: this.extractRelationshipCode(g.relationship),
      RelationshipDisplay: this.extractRelationshipDisplay(g.relationship),
      RelationshipSystem: this.extractRelationshipSystem(g.relationship)
        ?? 'http://terminology.hl7.org/CodeSystem/v3-RoleCode'
    };
  }

  // New/unregistered guardian — send their details
  const firstPhone = g.phone_telecom?.[0]?.value || null;
  const firstEmail = g.email_telecom?.[0]?.value || null;
  const name = g.name
    ? `${g.name.given || ''} ${g.name.family || ''}`.trim()
    : null;

  if (!name && !firstPhone && !firstEmail) return null;

  return {
    RelationshipCode: this.extractRelationshipCode(g.relationship),
    RelationshipDisplay: this.extractRelationshipDisplay(g.relationship),
    RelationshipSystem: this.extractRelationshipSystem(g.relationship)
      ?? 'http://terminology.hl7.org/CodeSystem/v3-RoleCode',
    Name: name,
    Phone: firstPhone,
    Email: firstEmail,
    Gender: g.gender?.toLowerCase() || null
  };
}
  /**
   * ✅ SELF-REGISTRATION: /api/Auth/register (requires approval)
   */
  private submitSelfRegistration(cleanedPatient: Patient): void {
    console.log('📤 SELF-REGISTRATION → /api/Auth/register');

    const firstEmail = this.getFirstEmail(cleanedPatient);
    const firstPhone = this.getFirstPhone(cleanedPatient);
    const firstName = cleanedPatient.name?.[0]?.given?.[0] || '';
    const lastName = cleanedPatient.name?.[0]?.family || '';

    if (!firstEmail) {
      this.errorService.openandCloseError('Email is required');
      return;
    }

    const request = {
      Email: firstEmail,
      FirstName: firstName,
      LastName: lastName,
      PhoneNumber: firstPhone || null,
      AccountType: 'Patient',
      RequestedRole: 'Patient',
      OrganizationId: this.organizationId,
      FhirPatientJson: JSON.stringify(cleanedPatient),
      RoleSpecificData: {
        gender: cleanedPatient.gender,
        birthDate: cleanedPatient.birthDate,
        hasGuardian: !!this.guardianSubmittedData,
        hasPhotos: !!(cleanedPatient.photo && cleanedPatient.photo.length > 0),
        agreements: this.buildAgreementReceipts(),
        notificationsOptIn: this.patientAgreementState.notificationsOptIn.accepted
      }
    };

    this.http.post(`${this.authBackendApiBaseUrl}/api/Auth/register`, request)
      .subscribe({
        next: (response: any) => {
          console.log('✅ Self-registration submitted:', response);

          this.persistTelemedicineConsent(cleanedPatient, this.resolveRemotePatientId(response));

          const message = response.warnings?.length > 0
            ? `Registration submitted with warnings. An administrator will review your application.`
            : 'Registration submitted! You will receive an email once approved.';

          this.snackBar.openFromComponent(SuccessMessageComponent, {
            data: { message, action: 'Close' },
            duration: 8000,
            horizontalPosition: 'center',
            verticalPosition: 'top'
          });

          // Clear session and redirect
          sessionStorage.removeItem('registrationFlow');
          sessionStorage.removeItem('selectedHospitalId');
          sessionStorage.removeItem('selectedHospitalName');

          setTimeout(() => this.router.navigate(['/login']), 3000);
        },
        error: (error) => {
          console.error('❌ Self-registration failed:', error);
          this.errorService.openandCloseError(
            error.error?.message || 'Registration failed. Please try again.'
          );
        }
      });
  }

  /**
   * ✅ PRACTITIONER-INITIATED: /api/Admin/register-patient-direct (auto-approved)
   */
  private submitPractitionerInitiatedRegistration(cleanedPatient: Patient): void {
    console.log('📤 PRACTITIONER-INITIATED → /api/Admin/register-patient-direct');

    const firstEmail = this.getFirstEmail(cleanedPatient);
    const firstPhone = this.getFirstPhone(cleanedPatient);
    const firstName = cleanedPatient.name?.[0]?.given?.[0] || '';
    const lastName = cleanedPatient.name?.[0]?.family || '';


    const request: any = {
  Email: firstEmail || null,       // make email optional
  FirstName: firstName,
  LastName: lastName,
  PhoneNumber: firstPhone || null,
  AccountType: 'Patient',
  RequestedRole: 'Patient',
  OrganizationId: this.organizationId,
  FhirPatientJson: JSON.stringify(cleanedPatient),
  RoleSpecificData: {
    gender: cleanedPatient.gender,
    birthDate: cleanedPatient.birthDate,
    hasGuardian: !!this.guardianSubmittedData,
    hasPhotos: !!(cleanedPatient.photo && cleanedPatient.photo.length > 0),
    agreements: this.buildAgreementReceipts(),
    notificationsOptIn: this.patientAgreementState.notificationsOptIn.accepted
  },
  GuardianInfo: this.buildGuardianInfoPayload()
};

    this.http.post(`${this.authBackendApiBaseUrl}/api/Admin/register-patient-direct`, request)
      .subscribe({
        next: (response: any) => {
          console.log('✅ Patient registered successfully (auto-approved):', response);

          const tempPassword = response.tempPassword;
          this.persistTelemedicineConsent(cleanedPatient, this.resolveRemotePatientId(response));

          // ✅ Show dialog with credentials instead of snackbar
          const dialogRef = this.dialog.open(PatientRegistrationSuccessDialogComponent, {
            data: {
              firstName: firstName,
              lastName: lastName,
              email: firstEmail,
              patientId: response.patientId,  
              tempPassword: tempPassword || 'Not provided',
              message: 'Patient account has been created and is ready to use.'
            },
            disableClose: true, // Force user to acknowledge by clicking close
            width: '600px',
            maxWidth: '95vw'
          });

          // Navigate after dialog is closed
          dialogRef.afterClosed().subscribe(() => {
            if (this.isInlineMode) {
              timer(500)
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(() => {
                  this.registrationComplete.emit();
                });
            } else {
              this.router.navigate(['/app/patient-registration/approved']);
            }
          });
        },
        error: (error) => {
          console.error('❌ Practitioner registration failed:', error);
          this.errorService.openandCloseError(
            error.error?.message || 'Failed to register patient. Please try again.'
          );
        }
      });
  }


private extractRelationshipCode(value: string): string {
  if (!value) return 'N';
  const parts = value.split('$#$');
  return parts[0] || 'N';
}

private extractRelationshipDisplay(value: string): string {
  if (!value) return 'Next-of-Kin';
  const parts = value.split('$#$');
  return parts[1] || parts[0] || 'Next-of-Kin';
}

private extractRelationshipSystem(value: string): string | null {
  if (!value) return null;
  const parts = value.split('$#$');
  return parts[2] || null;
}
  private buildAgreementReceipts(): Array<{ code: AgreementKey; accepted: boolean; acceptedOn: string | null; documentPath: string }> {
    return (Object.keys(this.patientAgreementState) as AgreementKey[]).map((key: AgreementKey) => ({
      code: key,
      accepted: this.patientAgreementState[key].accepted,
      acceptedOn: this.patientAgreementState[key].acceptedOn,
      documentPath: this.agreementLinks[key]
    }));
  }

  private resolveRemotePatientId(response: any): string | undefined {
    return response?.patientId || response?.patient?.id || response?.fhirPatient?.id;
  }

  private persistTelemedicineConsent(patient: Patient, remotePatientId?: string): void {
    if (!this.patientAgreementState.telemedicineConsent.accepted) {
      return;
    }

    const consentResource = this.buildTelemedicineConsentResource(patient, remotePatientId);

    this.http.post(`${this.backendApiBaseUrl}/Consent`, consentResource).subscribe({
      next: () => console.log('✅ Telemedicine consent stored for pending patient.'),
      error: (error) => console.error('❌ Unable to persist telemedicine consent:', error)
    });
  }

  private buildTelemedicineConsentResource(patient: Patient, remotePatientId?: string): Consent {
    const patientReference = this.buildConsentPatientReference(patient, remotePatientId);
    const performerReference: Reference = patientReference.reference
      ? { reference: patientReference.reference, display: patientReference.display }
      : {
        identifier: patientReference.identifier,
        display: patientReference.display
      };
    const acceptedOn = this.patientAgreementState.telemedicineConsent.acceptedOn || new Date().toISOString();

    return {
      resourceType: 'Consent',
      status: 'active',
      scope: {
        coding: [{
          system: 'http://terminology.hl7.org/CodeSystem/consentscope',
          code: 'treatment',
          display: 'Treatment'
        }]
      },
      category: [{
        coding: [{
          system: 'http://loinc.org',
          code: '64292-6',
          display: 'Consent for telehealth service'
        }]
      }],
      patient: patientReference,
      performer: [performerReference],
      organization: this.organizationId ? [{ reference: `Organization/${this.organizationId}` }] : undefined,
      dateTime: acceptedOn,
      policyRule: {
        coding: [{
          system: 'https://elikita.health/consent-policy',
          code: 'telemedicine-treatment',
          display: 'Telemedicine treatment consent'
        }]
      },
      policy: [{
        authority: 'https://elikita.health',
        uri: this.agreementLinks.telemedicineConsent
      }],
      provision: {
        type: 'permit',
        period: {
          start: acceptedOn
        },
        purpose: [{
          system: 'http://terminology.hl7.org/CodeSystem/v3-ActReason',
          code: 'TREAT',
          display: 'Treatment'
        }]
      },
      sourceAttachment: {
        title: 'Telemedicine Consent Summary',
        url: this.agreementLinks.telemedicineConsent
      },
      note: this.telemedicineConsentStatements.map(text => ({ text }))
    } as Consent;
  }

  private buildConsentPatientReference(patient: Patient, remotePatientId?: string): Reference {
    if (remotePatientId) {
      return { reference: `Patient/${remotePatientId}` };
    }

    if (patient.id) {
      return { reference: `Patient/${patient.id}` };
    }

    const firstIdentifier = patient.identifier?.find(id => !!id.value);
    if (firstIdentifier) {
      return {
        identifier: {
          system: firstIdentifier.system || 'https://elikita.health/patient-registration',
          value: firstIdentifier.value
        },
        display: this.buildPatientDisplay(patient)
      };
    }

    const firstEmail = this.getFirstEmail(patient);
    if (firstEmail) {
      return {
        identifier: {
          system: 'mailto:elikita.health',
          value: firstEmail
        },
        display: this.buildPatientDisplay(patient)
      };
    }

    return {
      display: this.buildPatientDisplay(patient) || 'Pending Patient'
    };
  }

  private buildPatientDisplay(patient: Patient): string {
    const firstName = patient.name?.[0]?.given?.join(' ') || '';
    const familyName = patient.name?.[0]?.family || '';
    return `${firstName} ${familyName}`.trim();
  }

  private getOrganizationDisplayNameForTag(): string {
    if (this.organizationDisplayName?.trim()) {
      return this.organizationDisplayName.trim();
    }

    const fromUser = this.resolveOrganizationDisplayFromUser(this.authService.user.getValue());
    if (fromUser) {
      this.organizationDisplayName = fromUser;
      return fromUser;
    }

    const fromSession = this.safeReadSelectedHospitalName();
    if (fromSession) {
      this.organizationDisplayName = fromSession;
      return fromSession;
    }

    return '';
  }

  private resolveOrganizationDisplayFromUser(user: User | null | undefined): string {
    if (!user) {
      return '';
    }

    const candidates: Array<string | undefined> = [
      (user as any)?.organizationName,
      (user as any)?.organization?.name,
      (user as any)?.organization?.display,
      (user as any)?.organizationDisplay,
      (user as any)?.hospitalName,
      (user as any)?.hospital?.name,
      (user as any)?.hospital?.display,
      (user as any)?.hospitalDisplay
    ];

    for (const candidate of candidates) {
      if (typeof candidate === 'string' && candidate.trim()) {
        return candidate.trim();
      }
    }

    return '';
  }

  private safeReadSelectedHospitalName(): string {
    const storageKeys = ['selectedOrganizationName', 'selectedHospitalName', 'hospitalName'];
    for (const key of storageKeys) {
      const fromSession = this.safeReadStorageItem(sessionStorage, key);
      if (fromSession) {
        return fromSession;
      }

      const fromLocal = this.safeReadStorageItem(localStorage, key);
      if (fromLocal) {
        return fromLocal;
      }
    }
    return '';
  }

  private safeReadStorageItem(storage: Storage, key: string): string {
    try {
      const value = storage.getItem(key);
      return value?.trim() || '';
    } catch {
      return '';
    }
  }
  goHome() {
    // Dismiss the snackbar if it exists
    if (this.hospitalBannerRef) {
      this.hospitalBannerRef.dismiss();
    }

    this.router.navigateByUrl('/');
  }
  // Also update the transformToFhirPatient method to ensure organization is always set
  getUserDisplayName(): string {
    const user = this.authService.user.getValue();

    if (!user) {
      return 'Unknown User';
    }

    const name = user.name;

    // Case 1: name is already a string
    if (typeof name === 'string' && name.trim().length > 0) {
      return name;
    }

    // Case 2: FHIR HumanName[]
    if (Array.isArray(name) && name.length > 0) {
      const n: HumanName = name[0];

      const given =
        Array.isArray(n.given) && n.given.length > 0
          ? n.given.join(' ')
          : '';

      const family = typeof n.family === 'string' ? n.family : '';

      const fullName = `${given} ${family}`.trim();

      if (fullName.length > 0) {
        return fullName;
      }
    }

    // Case 3: fallback
    if (typeof user.email === 'string' && user.email.trim().length > 0) {
      return user.email;
    }

    return 'Unknown User';
  }

  getUserRoleDisplay(): string {
    const role = this.authService.user.getValue()?.role || '';
    return role.charAt(0).toUpperCase() + role.slice(1);
  }
  // Helper methods
  private getFirstEmail(patient: Patient): string {
    return patient.telecom?.find(t => t.system === 'email')?.value || '';
  }

  private getFirstPhone(patient: Patient): string {
    return patient.telecom?.find(t => t.system === 'phone')?.value || '';
  }
  /**
   * Recursively prune empty entries in FHIR arrays and objects.
   * Rules:
   *  - In arrays: drop elements that are primitives with empty string/null/undefined; or objects that become empty after pruning
   *  - In objects: remove properties that become empty (empty arrays/objects/empty strings/null/undefined)
   *  - Booleans and numbers are kept as-is (false/0 are valid values)
   */
  private pruneFHIRArrays<T>(input: T): T {
    const isPrimitive = (v: any) => v === null || v === undefined || typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean';

    const isEmptyPrimitive = (v: any) => v === null || v === undefined || (typeof v === 'string' && v.trim() === '');

    const prune = (val: any): any => {
      if (Array.isArray(val)) {
        const pruned = val
          .map(item => prune(item))
          .filter(item => {
            if (Array.isArray(item)) return item.length > 0;
            if (item && typeof item === 'object') return Object.keys(item).length > 0;
            return !isEmptyPrimitive(item);
          });
        return pruned;
      }
      if (val && typeof val === 'object') {
        const result: any = {};
        for (const [k, v] of Object.entries(val)) {
          const pv = prune(v);
          // Keep numbers and booleans regardless of falsy-ness
          const keepNumberBoolean = typeof pv === 'number' || typeof pv === 'boolean';
          if (keepNumberBoolean) { result[k] = pv; continue; }
          if (Array.isArray(pv)) {
            if (pv.length > 0) result[k] = pv;
            continue;
          }
          if (pv && typeof pv === 'object') {
            if (Object.keys(pv).length > 0) result[k] = pv;
            continue;
          }
          if (!isEmptyPrimitive(pv)) result[k] = pv;
        }
        return result;
      }
      // primitives
      return val;
    }

    return prune(input);
  }

  private sanitizePatientResource(patient: Patient): void {
    if (!patient) {
      return;
    }

    if (Array.isArray(patient.telecom)) {
      patient.telecom = patient.telecom.filter((tp: any) => this.hasContactPointValue(tp?.value));
    }

    if (Array.isArray(patient.identifier)) {
      patient.identifier = patient.identifier.filter(id => this.hasContactPointValue(id?.value));
    }

    if (Array.isArray(patient.contact)) {
      patient.contact = patient.contact
        .map(contact => this.sanitizeContactEntry(contact))
        .filter(contact => this.contactHasMeaningfulData(contact));
    }
  }

  private sanitizeContactEntry(contact: any): any {
    if (!contact) {
      return contact;
    }

    if (Array.isArray(contact.telecom)) {
      contact.telecom = contact.telecom.filter((tp: any) => this.hasContactPointValue(tp?.value));
    }

    return contact;
  }

  private contactHasMeaningfulData(contact: any): boolean {
    if (!contact) {
      return false;
    }

    const hasRelationship = Array.isArray(contact.relationship) && contact.relationship.length > 0;
    const hasTelecom = Array.isArray(contact.telecom) && contact.telecom.length > 0;
    const hasAddress = Array.isArray(contact.address)
      ? contact.address.length > 0
      : !!(contact.address && Object.keys(contact.address).length > 0);
    const hasOrganization = contact.organization && this.hasContactPointValue(contact.organization.reference);
    const hasPeriod = !!contact.period;
    const hasGender = this.hasContactPointValue(contact.gender);
    const hasName = !!(
      contact.name &&
      (
        this.hasContactPointValue(contact.name.family) ||
        (Array.isArray(contact.name.given) && contact.name.given.some((g: any) => this.hasContactPointValue(g)))
      )
    );

    return hasRelationship || hasTelecom || hasAddress || hasOrganization || hasPeriod || hasGender || hasName;
  }

  private hasContactPointValue(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }

    if (typeof value === 'string') {
      return value.trim().length > 0;
    }

    return true;
  }

  private normalizeCodeableConcept(input: any): any | undefined {
    if (!input) {
      return undefined;
    }

    if (typeof input === 'string') {
      return this.parseCodeableConcept(input) || undefined;
    }

    if (input.coding || input.text) {
      return input;
    }

    const coding: any = {};
    if (input.code) {
      coding.code = input.code;
    }
    if (input.display) {
      coding.display = input.display;
    }
    if (input.system) {
      coding.system = input.system;
    }

    if (Object.keys(coding).length === 0) {
      return undefined;
    }

    return {
      coding: [coding],
      text: input.display || input.text || input.code
    };
  }
  /**
   * Toggle FHIR panel collapsed/expanded state
   */
  toggleFhirPanel(): void {
    this.isFhirPanelCollapsed = !this.isFhirPanelCollapsed;
  }
  // backendApiBaseUrl = inject(backendEndPointToken);
  /**
   * Transform form data to FHIR R4 Patient resource
   */
  async transformToFhirPatient(formData: any, guardianData?: any): Promise<Patient> {
    // Get organization ID from session
    const organizationId = this.resolveOrganizationIdFromForm(formData?.managingOrganization);

    // ✅ Create patient object with explicit type
    const patient: Patient = {
      resourceType: 'Patient',
      active: formData.active ?? true,
      name: formData.name ? [this.transformName(formData.name)] : [],
      gender: formData.gender?.toLowerCase() as 'male' | 'female' | 'other' | 'unknown',
      birthDate: this.formatBirthDate(formData.birthDate),
      maritalStatus: this.parseCodeableConcept(formData.maritalStatus),
      telecom: this.mergeTelecom(formData),
      address: formData.address || []
    };

    if (organizationId) {
      patient.managingOrganization = {
        reference: `Organization/${organizationId}`
      };
    }

    // ✅ Initialize identifiers array if not present
    if (!patient.identifier) {
      patient.identifier = [];
    }

    // Add NIN identifier
    if (formData.nin) {
      this.generateIdentifier(patient, {
        type: {
          code: 'nin-ng-others',
          display: 'National Identification Number',
          system: `${this.canonicalTerminologyServer}/CodeSystem/identifier-type`
        },
        value: formData.nin,
        use: 'secondary'
      });
    }

    // Add other identifiers
    if (formData.ids && Array.isArray(formData.ids)) {
      formData.ids.forEach((idObj: any) => {
        this.generateIdentifier(patient, {
          type: idObj.type,
          system: `${this.canonicalTerminologyServer}/CodeSystem/identifier-type`,
          value: idObj.value,
          use: 'secondary'
        });
      });
    }

    // Add guardian/contact information if available
    if (guardianData) {
      patient.contact = this.transformGuardianToFhirContact(guardianData);
    }

    this.applyPhotoAttachments(patient);

    return patient;
  }

  private resolveOrganizationIdFromForm(formValue: any): string | undefined {
    if (this.canSelectOrganization) {
      const extracted = this.extractOrganizationId(formValue);
      if (extracted) {
        return extracted;
      }
    }
    return this.organizationId || undefined;
  }

  private extractOrganizationId(value: any): string | undefined {
    if (!value) {
      return undefined;
    }

    if (typeof value === 'string') {
      return value.includes('/') ? value.split('/').pop() || undefined : value;
    }

    if (typeof value === 'object') {
      if (typeof value.reference === 'string') {
        return value.reference.split('/').pop() || undefined;
      }
      if (typeof value.id === 'string') {
        return value.id;
      }
    }

    return undefined;
  }

  private applyPhotoAttachments(patient: Patient): void {
    if (!patient) {
      return;
    }

    if (!this.uploadedPhotos || this.uploadedPhotos.length === 0) {
      delete patient.photo;
      return;
    }

    patient.photo = this.uploadedPhotos.map(file => ({
      contentType: file.uploadFileType,
      url: file.fileLink,
      title: file.uploadFileName,
      size: file.uploadFileSize,
      creation: this.resolveAttachmentCreationDate(file)
    }));
  }

  private resolveAttachmentCreationDate(file: any): string {
    const raw = file?.creation || file?.uploadedOn || file?.uploadDate;
    if (typeof raw === 'string' && raw.trim().length > 0) {
      return raw.split('T')[0];
    }
    return new Date().toISOString().split('T')[0];
  }

  /**
   * Transform guardian/dependent data to FHIR Patient.contact format
   */
  transformGuardianToFhirContact(guardianData: any): any[] {
    if (!guardianData) return [];

    const contacts: any[] = [];

    // Guardian data might be an array or single object
    const guardianArray = Array.isArray(guardianData) ? guardianData : [guardianData];

    guardianArray.forEach((guardian: any) => {
      const contact: any = {};

      // Relationship
      if (guardian.relationship) {
        contact.relationship = [this.parseCodeableConcept(guardian.relationship)];
      }

      // Name
      if (guardian.name) {
        contact.name = this.transformName(guardian.name);
      }

      // Telecom (phone, email)
      const telecom: any[] = [];
      if (guardian.phone_telecom && Array.isArray(guardian.phone_telecom)) {
        telecom.push(...guardian.phone_telecom);
      }
      if (guardian.email_telecom && Array.isArray(guardian.email_telecom)) {
        telecom.push(...guardian.email_telecom);
      }
      if (guardian.telecom && Array.isArray(guardian.telecom)) {
        telecom.push(...guardian.telecom);
      }
      if (telecom.length > 0) {
        contact.telecom = telecom;
      }

      // Address
      if (guardian.address && Array.isArray(guardian.address)) {
        contact.address = guardian.address[0]; // FHIR contact.address is not an array
      }

      // Gender
      if (guardian.gender) {
        contact.gender = guardian.gender.toLowerCase() as 'male' | 'female' | 'other' | 'unknown';
      }

      // Organization (if guardian is an organization)
      if (guardian.organization) {
        contact.organization = {
          reference: guardian.organization
        };
      }

      // Period (if there's a time period for this contact)
      if (guardian.period) {
        contact.period = guardian.period;
      }

      contacts.push(contact);
    });

    return contacts;
  }

  /**
   * Dismiss validation bar
   */
  dismissValidationBar(): void {
    this.showValidationBar = false;
  }


  /**
 * Format birth date to FHIR date format (YYYY-MM-DD)
 * Handles datetime-local input which returns ISO datetime string
 */
  private formatBirthDate(birthDate: string | undefined): string | undefined {
    if (!birthDate) {
      return undefined;
    }

    try {
      // If it's already in YYYY-MM-DD format, return as-is
      if (/^\d{4}-\d{2}-\d{2}$/.test(birthDate)) {
        return birthDate;
      }

      // Parse the datetime string and extract just the date part
      const date = new Date(birthDate);

      // Check if date is valid
      if (isNaN(date.getTime())) {
        console.warn('Invalid birth date:', birthDate);
        return undefined;
      }

      // Format as YYYY-MM-DD
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    } catch (error) {
      console.error('Error formatting birth date:', error);
      return undefined;
    }
  }
  /**
   * Get count of required errors
   */
  getRequiredErrorCount(): number {
    return Object.values(this.validationTracker.required).filter(field => !(field as any)?.valid).length;
  }

  //generate identifier
  generateIdentifier(patient: Patient, identifierData: any): void {
    if (!identifierData) {
      return;
    }

    const rawValue = identifierData.value;
    const normalizedValue = typeof rawValue === 'string' ? rawValue.trim() : rawValue;
    if (normalizedValue === undefined || normalizedValue === null || (typeof normalizedValue === 'string' && normalizedValue.length === 0)) {
      return;
    }

    if (!patient.identifier) {
      patient.identifier = [];
    }

    const identifier: Identifier = {
      value: typeof normalizedValue === 'string' ? normalizedValue : String(normalizedValue)
    };

    if (identifierData.use) {
      identifier.use = identifierData.use as 'official' | 'secondary' | 'usual' | 'temp' | 'old';
    }

    const normalizedType = this.normalizeCodeableConcept(identifierData.type);
    if (normalizedType) {
      identifier.type = normalizedType;
    }

    if (identifierData.system) {
      identifier.system = identifierData.system;
    }

    if (identifierData.assigner) {
      identifier.assigner = identifierData.assigner;
    }

    patient.identifier.push(identifier);
  }
  /**
   * Get count of recommended errors
   */
  getRecommendedErrorCount(): number {
    return Object.values(this.validationTracker.recommended).filter(field => !(field as any)?.valid).length;
  }

  /**
   * Transform name field
   */
  private transformName(name: any): any {
    return {
      use: 'official',
      prefix: name.title ? [name.title] : undefined,
      family: name.family,
      given: name.given ? [name.given, ...(name.otherNames ? [name.otherNames] : [])].filter(n => n) : []
    };
  }

  /**
   * Parse serialized CodeableConcept (format: "code$#$display$#$system")
   */
  private parseCodeableConcept(value: string): any {
    if (!value) return undefined;

    const parts = value.split('$#$');
    if (parts.length >= 3) {
      return {
        coding: [{
          code: parts[0],
          display: parts[1],
          system: parts[2]
        }],
        text: parts[1]
      };
    }
    return undefined;
  }
  /**
  * Parse serialized Reference (format: "reference$#$display")
  */
  private parseReference(value: string): any {
    if (!value) return undefined;

    const parts = value.split('$#$');
    if (parts.length >= 2) {
      return {
        reference: parts[0],
        display: parts[1]
      };
    }
    return undefined;
  }

  /**
   * Merge all telecom arrays (phone, email, other contacts)
   */
  private mergeTelecom(formData: any): any[] {
    const telecom: any[] = [];

    // Add phone contacts
    if (formData.phone_telecom && Array.isArray(formData.phone_telecom)) {
      telecom.push(...formData.phone_telecom);
    }

    // Add email contacts
    if (formData.email_telecom && Array.isArray(formData.email_telecom)) {
      telecom.push(...formData.email_telecom);
    }

    // Add other contacts
    if (formData.telecom && Array.isArray(formData.telecom)) {
      telecom.push(...formData.telecom);
    }

    return telecom;
  }

  /**
   * Helper method for template - get object keys
   */
  objectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  /**
   * Helper method for template - check if value is array
   */
  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  /**
   * Format field value for display
   */
 formatFieldValue(field: any, data: any): string {
  // Guard against undefined/malformed field
  if (!field || !field.generalProperties) {
    return data ? String(data) : '';
  }

  const apiName = field.generalProperties.fieldApiName;

  // Handle birthDate
  if (apiName === 'birthDate' && data) {
    const date = new Date(data);
    return date.toLocaleDateString();
  }

  // Handle maritalStatus - extract display text only
  if (apiName === 'maritalStatus' && data) {
    if (typeof data === 'string' && data.includes('$#$')) {
      const parts = data.split('$#$');
      return parts[1] || data;
    }
    return data;
  }

  // Handle group fields like 'name'
  if (field.generalProperties.isGroup && data) {
    if (apiName === 'name') {
      const title = data.title || '';
      const given = data.given || '';
      const otherNames = data.otherNames || '';
      const family = data.family || '';
      return `${title} ${given} ${otherNames} ${family}`.trim().replace(/\s+/g, ' ');
    }
    return JSON.stringify(data);
  }

  // Handle simple fields
  return data ? String(data) : '';
}

  private patientNumberSecond = 0;
  private patientNumberSequence = 0;

  /**
   * Generate an 11-digit numeric patient identifier.
   * Structure: PP TTTTTTT SS
   *   - PP: 2-digit hospital-specific hash (ensures per-organization namespace)
   *   - TTTTTTT: last 7 digits of the current epoch second (keeps IDs sortable & time-based)
   *   - SS: 2-digit per-second sequence (prevents clashes when multiple IDs are minted within the same second)
   */
  private async generateElevenDigitsPatientNumber(): Promise<string> {
    const hosIdFromUserOrAppConfig = this.authService.user?.getValue()?.['hospitalId'] || hardCodedHospitalId || '';
    const prefix = this.deriveHospitalNumericPrefix(hosIdFromUserOrAppConfig);
    const currentSecond = Math.floor(Date.now() / 1000);
    const timestampPart = (currentSecond % 10_000_000).toString().padStart(7, '0');
    const sequencePart = this.nextSequenceDigits(currentSecond);
    return `${prefix}${timestampPart}${sequencePart}`;
  }

  private deriveHospitalNumericPrefix(hospitalId: string): string {
    if (!hospitalId) {
      return '00';
    }

    let hash = 0;
    for (const char of hospitalId) {
      hash = (hash * 31 + char.charCodeAt(0)) % 100;
    }

    return hash.toString().padStart(2, '0');
  }

  private getStaticMaritalStatus(): string[] {
    return [
      'S$#$Single$#$http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
      'M$#$Married$#$http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
      'D$#$Divorced$#$http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
      'W$#$Widowed$#$http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
      'L$#$Legally Separated$#$http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
      'UNK$#$Unknown$#$http://terminology.hl7.org/CodeSystem/v3-NullFlavor',
    ];
  }

  private getStaticRelationships(): string[] {
    return [
      'N$#$Next-of-Kin$#$http://terminology.hl7.org/CodeSystem/v2-0131',
      'EP$#$Emergency contact$#$http://terminology.hl7.org/CodeSystem/v2-0131',
      'C$#$Emergency Contact$#$http://terminology.hl7.org/CodeSystem/v2-0131',
      'PRN$#$Parent$#$http://terminology.hl7.org/CodeSystem/v3-RoleCode',
      'SPS$#$Spouse$#$http://terminology.hl7.org/CodeSystem/v3-RoleCode',
      'CHILD$#$Child$#$http://terminology.hl7.org/CodeSystem/v3-RoleCode',
      'GUARD$#$Guardian$#$http://terminology.hl7.org/CodeSystem/v3-RoleCode',
    ];
  }
  private nextSequenceDigits(currentSecond: number): string {
    if (currentSecond === this.patientNumberSecond) {
      this.patientNumberSequence = (this.patientNumberSequence + 1) % 100;
    } else {
      this.patientNumberSecond = currentSecond;
      this.patientNumberSequence = 0;
    }

    return this.patientNumberSequence.toString().padStart(2, '0');
  }
  authService = inject(AuthService);
}
